import SiteLayout from '@/components/feature/SiteLayout';
import Container from '@/components/base/Container';
import SectionLabel from '@/components/base/SectionLabel';
import InquiryForm from '@/components/feature/InquiryForm';

const STEPS = [
  { n: '01', t: 'Inquiry', d: 'Share a few lines about your situation using the form.' },
  { n: '02', t: 'Reply', d: 'A partner reviews your note and replies by email.' },
  { n: '03', t: 'Conversation', d: 'An initial, no-obligation conversation to understand your needs.' },
];

export default function ContactPage() {
  return (
    <SiteLayout title="Contact | AVENOR Accounting & Advisory">
      <section className="relative overflow-hidden bg-white pb-24 pt-32 md:pb-32 md:pt-44">
        <Container className="relative">
          <SectionLabel index="06" label="Let's Talk" />
          <div className="mt-12 grid grid-cols-1 gap-14 md:mt-16 lg:grid-cols-12 lg:gap-6">
            <div className="lg:col-span-5">
              <h1 className="font-heading text-[44px] font-light leading-[1.02] tracking-[-0.025em] md:text-[72px]">
                Start with a conversation<span className="text-primary-500">.</span>
              </h1>
              <p className="mt-8 max-w-sm text-[15px] leading-[1.7] text-foreground-700 md:text-base">
                Whether you are planning ahead or facing an immediate question, the first step is simply to tell us about it.
              </p>
              <ol className="mt-12 border-t border-background-200">
                {STEPS.map((s) => (
                  <li key={s.n} className="grid grid-cols-[48px_1fr] gap-4 border-b border-background-200 py-5">
                    <span className="font-label text-xs text-primary-500">{s.n}</span>
                    <div>
                      <p className="text-base text-foreground-950">{s.t}</p>
                      <p className="mt-1 text-sm leading-relaxed text-foreground-700">{s.d}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
            <div className="flex flex-col justify-end lg:col-span-6 lg:col-start-7">
              <div>
                <InquiryForm id="contact-inquiry" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </SiteLayout>
  );
}